import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const tabs = document.querySelectorAll('[data-tab]');
    const contents = document.querySelectorAll('.tab-content');
    
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const target = this.getAttribute('data-tab');
        
        tabs.forEach(t => {
          t.classList.remove('border-blue-500', 'text-blue-600');
          t.classList.add('border-transparent', 'text-gray-500');
        });
        
        this.classList.add('border-blue-500', 'text-blue-600');
        this.classList.remove('border-transparent', 'text-gray-500');
        
        contents.forEach(content => content.style.display = 'none');
        
        const targetContent = document.getElementById(target);
        if (targetContent) {
          targetContent.style.display = 'block';
        }
      });
    });
  }
}